import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';
import {InputText} from 'primereact/inputtext';
import {recruitmentApi} from '../recruitmentApi';

const CandidateEducationFormComponent = ({t, candidateId, backlink}) => {
  const history = useHistory();
  const {entity, id} = useParams();
  const educationId = window.App.urlVars().candidateEducationId || (entity === 'candidate-education' && id);
  const [values, setValues] = useState({});
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [loadFailed, setLoadFailed] = useState(false);
  useEffect(() => {
    let active = true;
    Promise.all([recruitmentApi('get', '/candidate/profile-options'), educationId ? recruitmentApi('get', '/candidate-education/' + educationId) : Promise.resolve(null)])
      .then(([dictionary, record]) => {
        if (!active) return;
        const data = record?.data.data || {};
        const levels = dictionary.data.data.education_level || [];
        const choices = levels.map(l => ({label: l.name, value: 'id:' + l.id}));
        ['ELEMENTARY_SCHOOL', 'HIGH_SCHOOL', 'BSC', 'MSC'].forEach(level => choices.push({label: t('candidateEducationLevel.' + level, {defaultValue: level}), value: level}));
        const selected = data.education_level ? 'id:' + data.education_level.id : data.level;
        if (selected && !choices.some(c => c.value === selected)) choices.push({label: data.level, value: selected});
        setOptions(choices); setValues({...data, selected});
      }).catch(() => { if (active) { setLoadFailed(true); setError(t('error')); } })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [educationId, t]);
  const save = async event => {
    event.preventDefault();
    if (!values.selected || loadFailed) return;
    setLoading(true); setError('');
    const reference = String(values.selected).startsWith('id:');
    const payload = {candidate: Number(candidateId), education_level: reference ? Number(values.selected.slice(3)) : null,
      level: reference ? options.find(o => o.value === values.selected).label : values.selected,
      school: values.school || null, master: values.master || null, end_date: values.end_date ? values.end_date.slice(0, 10) : null};
    try {
      await recruitmentApi(educationId ? 'patch' : 'post', '/candidate-education' + (educationId ? '/' + educationId : ''), payload);
      window.App.setState({rerenderCandidateEducationList: Math.random(), rerenderCandidateShow: Math.random()});
      history.push(backlink || '/recruitment/candidate/read/' + candidateId);
    } catch (error) { setError(error.response?.data?.detail || error.response?.data?.message || t('error')); }
    finally { setLoading(false); }
  };
  return <form className="candidate-education-form widget" onSubmit={save}>
    {error && <p className="p-error" role="alert">{error}</p>}
    <div className="p-field p-fluid"><label htmlFor="education-level">{t('fieldEducationLevel')}</label>
      <Dropdown inputId="education-level" value={values.selected} options={options} filter disabled={loading || loadFailed} onChange={e => setValues({...values, selected: e.value})}/></div>
    {[['master', 'fieldEducationName', 'Végzettség megnevezése'], ['school', 'fieldSchool', 'Intézmény'], ['end_date', 'fieldEducationCompletionDate', 'Befejezés dátuma']].map(([name, key, fallback]) =>
      <div key={name} className="p-field p-fluid"><label htmlFor={'education-' + name}>{t(key, {defaultValue: fallback})}</label>
        <InputText id={'education-' + name} type={name === 'end_date' ? 'date' : 'text'} disabled={loading || loadFailed}
          value={name === 'end_date' ? (values[name] || '').slice(0, 10) : values[name] || ''} onChange={e => setValues({...values, [name]: e.target.value})}/></div>)}
    <div className="p-text-right"><Button type="submit" label={t('saveAndBack')} icon="pi pi-save" loading={loading} disabled={loadFailed || !values.selected}/></div>
  </form>;
};
export default withTranslation('common')(CandidateEducationFormComponent);
